<scf-register-user [mode]="'detail'"></scf-register-user>
